import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import {
  ClassesGetByIdInterface,
  CourseClassByIdInterface,
  CourseClassInterface,
  coursesCreateInterface,
  coursesDataInterface,
  UserCourseDataInterface,
} from "../types/types";

export const courses = {
  CreateCourses: (body: coursesCreateInterface): Promise<any> => {
    return HttpClient.post(API_ENDPOINTS.COURSES, body);
  },
  CreateCoursesClass: (
    body: CourseClassInterface,
    courseId: number
  ): Promise<any> => {
    return HttpClient.post(`${API_ENDPOINTS.COURSES_CLASS}/${courseId}`, body);
  },

  GetCourseData: (options?: any) => {
    return HttpClient.get<coursesDataInterface>(API_ENDPOINTS.COURSES, options);
  },
  GetCourseById: (id?: number) => {
    return HttpClient.get<ClassesGetByIdInterface>(
      `${API_ENDPOINTS.COURSES}/${id}`
    );
  },
  GetCourseClassById: (option?: any) => {
    return HttpClient.get<CourseClassByIdInterface>(
      API_ENDPOINTS.COURSES_CLASS,
      option
    );
  },
  GetUserCourseData: (options?: any) => {
    return HttpClient.get<UserCourseDataInterface>(API_ENDPOINTS.USER_COURSE, options);
  },
  UpdateCourse: (body: coursesCreateInterface, id: number) => {
    return HttpClient.put<coursesCreateInterface>(
      `${API_ENDPOINTS.COURSES}/${id}`,
      body
    );
  },
  UpdateCourseClass: (body: any, id: number) => {
    return HttpClient.put(`${API_ENDPOINTS.COURSES_CLASS}/${id}`, body);
  },
  deleteCourses: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.COURSES}/${id}`);
  },
  deleteCoursesClass: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.COURSES_CLASS}/${id}`);
  },
};
